import React from "react";
import { Route, Routes } from "react-router-dom";
import Main from "./Main";
import Chat from "./Chat";

const AppRoutes = () => {
   return (
      <Routes>
         <Route path="/frontend-developers/" element={<Main />} />
         <Route path="/frontend-developers/chat" element={<Chat />} />
      </Routes>
   );
};

export default AppRoutes 